/**
 * PATCH `admin/trial-features` — пакетно включить/выключить права триала.
 * Применяется сразу (кеш триал-прав на BE сбрасывается), неизвестный ключ
 * → 422 и ничего не меняется. Ответ — полный свежий каталог.
 */

import {apiEnabled, http} from '@services/utils';

import {applyTrialUpdateMock} from '../mocks';
import {toTrialFeatures} from '../toTrialFeatures';
import type {TrialFeature, UpdateTrialFeaturesInput} from '../types';

const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

export const updateTrialFeatures = async (
  input: UpdateTrialFeaturesInput,
): Promise<TrialFeature[]> => {
  if (!apiEnabled) {
    await sleep(500);
    return applyTrialUpdateMock(input);
  }

  const raw = await http<Record<string, unknown>>('admin/trial-features', {
    method: 'PATCH',
    body: {items: input.items},
    skipCaseConversion: true,
  });
  return toTrialFeatures(raw);
};
